import { Box, BoxProps } from 'styled-system/jsx';

export const VLine = (props: BoxProps) => {
  return <Box w="1px" background="greyWhite.outline" {...props} />;
};

export const HLine = (props: BoxProps) => {
  return <Box h="1px" background="greyWhite.outline" {...props} />;
};
